/**
 * Owner: Masa Bayu
 * File: PwaPhaseAContext.tsx
 * Date:Time: 2026-09-22 06:02
 * Description: Phase A shared PWA state — one SW registration · Install + update UX.
 */

import { createContext, useContext, type ReactNode } from 'react';
import { PwaShellUpdateBanner } from './PwaShellUpdateBanner';
import { usePwaPhaseA, type PwaPhaseAState } from './use-pwa-phase-a';

const PwaPhaseAContext = createContext<PwaPhaseAState | null>(null);

export function PwaPhaseAProvider({ children }: { readonly children: ReactNode }) {
  const pwa = usePwaPhaseA();
  return (
    <PwaPhaseAContext.Provider value={pwa}>
      <div
        data-pwa-phase-a="chrome"
        data-pwa-standalone={String(pwa.standalone)}
        data-pwa-install-mode={pwa.install.mode}
      >
        <PwaShellUpdateBanner
          update={pwa.shellUpdate}
          onUpdate={() => {
            void pwa.applyShellUpdate();
          }}
          onLater={pwa.dismissShellUpdate}
        />
      </div>
      {children}
    </PwaPhaseAContext.Provider>
  );
}

export function usePwaPhaseAContext(): PwaPhaseAState {
  const value = useContext(PwaPhaseAContext);
  if (value === null) {
    throw new Error('usePwaPhaseAContext requires PwaPhaseAProvider');
  }
  return value;
}

export function useOptionalPwaPhaseA(): PwaPhaseAState | null {
  return useContext(PwaPhaseAContext);
}
